import React, { Component } from "react";
import HomeSlider1Image from "../../../assets/Slider4/1.png";
import HomeSlider2Image from "../../../assets/Slider4/2.png";
import HomeSlider3Image from "../../../assets/Slider4/3.png";
import HomeSlider4Image from "../../../assets/Slider4/4.png";
 import "./HomeSlider4.css";

class HomeSlider4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
    this.imageUrls = [
      HomeSlider1Image,
      HomeSlider2Image,
      HomeSlider3Image,
      HomeSlider4Image
 
    ];
  }

  componentDidMount() {
    this.slideInterval = setInterval(this.slideNext, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.slideInterval);
  }

  slideNext = () => {
    this.setState((prevState) => ({
      currentIndex: (prevState.currentIndex + 1) % this.imageUrls.length,
    }));
  };

  goToSlide = (index) => {
    this.setState({ currentIndex: index });
  };

  render() {
    const { currentIndex } = this.state;
    const translateX = `translateX(-${currentIndex * 100}%)`;

    return (
      <div className="slider-1-container">
        <div
          className="slider-images"
          style={{
            transform: translateX,
          }}
        >
          {this.imageUrls.map((imageUrl, index) => (
            <img
              key={index}
              src={imageUrl}
              alt={`Slide ${index + 1}`}
              className={`slider-image ${
                currentIndex === index ? "active" : ""
              }`}
            />
          ))}
        </div>
        <div className="slider-navigation">
          {this.imageUrls.map((_, index) => (
            <div
              key={index}
              className={`slider-circle ${
                currentIndex === index ? "active" : ""
              }`}
              onClick={() => this.goToSlide(index)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="#CBCBCB"
              >
                <path d="M5.76478 10.9412C4.31389 10.9412 2.92242 10.3648 1.89649 9.33888C0.870553 8.31294 0.294189 6.92148 0.294189 5.47059C0.294189 4.0197 0.870553 2.62823 1.89649 1.6023C2.92242 0.576364 4.31389 0 5.76478 0C7.21567 0 8.60713 0.576364 9.63307 1.6023C10.659 2.62823 11.2354 4.0197 11.2354 5.47059C11.2354 6.92148 10.659 8.31294 9.63307 9.33888C8.60713 10.3648 7.21567 10.9412 5.76478 10.9412ZM5.76478 9.57353C6.85295 9.57353 7.89654 9.14126 8.66599 8.37181C9.43545 7.60235 9.86772 6.55876 9.86772 5.47059C9.86772 4.38242 9.43545 3.33882 8.66599 2.56937C7.89654 1.79992 6.85295 1.36765 5.76478 1.36765C4.67661 1.36765 3.63301 1.79992 2.86356 2.56937C2.09411 3.33882 1.66184 4.38242 1.66184 5.47059C1.66184 6.55876 2.09411 7.60235 2.86356 8.37181C3.63301 9.14126 4.67661 9.57353 5.76478 9.57353Z" />
              </svg>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default HomeSlider4;
